import { GoogleAuthProvider, TwitterAuthProvider, OAuthProvider } from 'firebase/auth'
import { useContext } from 'react'
import { AuthenticationContext } from './context/AuthenticationProvider'

const googleAuthProvider = new GoogleAuthProvider()
const twitterAuthProvider = new TwitterAuthProvider()
const appleProvider = new OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')

export const PROVIDERS = {
  googleAuthProvider,
  twitterAuthProvider,
  appleProvider
}

export const useAuthentication = () => {
  const { authenticationService } = useContext(AuthenticationContext)

  return {
    authenticationService
  }
}
